'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-layout-overview {\n  position: relative;\n  z-index: 1;\n  box-sizing: border-box; }\n  .varta-layout-overview main {\n    padding: 60px 0 60px;\n    max-width: 1280px;\n    margin: 0 auto;\n    width: 100%; }\n    @media (min-width: 1024px) {\n      .varta-layout-overview main {\n        padding-top: 100px;\n        padding-bottom: 80px; } }\n";
styleInject_es(css_248z);
